'use strict';

module.exports = /* @ngInject */ function ($scope, quotationService, FileSaver, Blob, translationService) {

	$scope.download = download;
	$scope.loading = false;

	/**
	 * Downloads the excel file provided by EPROC-Api
	 * @param {string} rfqGroupId - rfq group id to determine the comparison
	 */
	function download(rfqGroupId){
		if(!$scope.loading){
			$scope.loading = true;
			quotationService.downloadQuotationComparison.query({rfqGroupId}).$promise.then((response) => {
				const contentType = response.headers('Content-Type');
				const blob = new Blob([new Uint8Array(response.data)], {
					type: contentType
				});
				const filename = _('Angebotsvergleich');
				FileSaver.saveAs(blob, translationService.translate(filename));
				$scope.loading = false;
			})
		}
	}
}
